// Subscription Types
export const BASIC = "basic";
export const BUSINESS = "business";
export const ENTERPRISE = "enterprise";
export const UNLIMITED = "unlimited";
export const A = "A";
export const B = "B";
export const C = "C";
export const BASE_URL = process.env.VUE_APP_API_URL;
export const basicMembershipHrs = 20;
export const businessMembershipHrs = 55;
export const POSITION_OFFSET = 2 ** 20;
export const DEBOUNCE_DELAY = 500;
export const APP_NAME = "Public Support";

export const USER_ROLES = {
  ADMIN: "admin",
  ASSISTANT: "assistant",
  OWNER: "owner"
};

export const HEADROOM_BILLING_ENTITIES = {
  EU: "Public Support Assistance BV (EU)",
  US: "Public Support Assistance Services LLC (US)"
};
export const countriesListJSON = [
  {
    id: "1",
    sortname: "AF",
    name: "Afghanistan",
    phonecode: "93"
  },
  {
    id: "2",
    sortname: "AL",
    name: "Albania",
    phonecode: "355"
  },
  {
    id: "3",
    sortname: "DZ",
    name: "Algeria",
    phonecode: "213"
  },
  {
    id: "4",
    sortname: "AS",
    name: "American Samoa",
    phonecode: "1684"
  },
  {
    id: "5",
    sortname: "AD",
    name: "Andorra",
    phonecode: "376"
  },
  {
    id: "6",
    sortname: "AO",
    name: "Angola",
    phonecode: "244"
  },
  {
    id: "7",
    sortname: "AI",
    name: "Anguilla",
    phonecode: "1264"
  },
  {
    id: "8",
    sortname: "AQ",
    name: "Antarctica",
    phonecode: "0"
  },
  {
    id: "9",
    sortname: "AG",
    name: "Antigua And Barbuda",
    phonecode: "1268"
  },
  {
    id: "10",
    sortname: "AR",
    name: "Argentina",
    phonecode: "54"
  },
  {
    id: "11",
    sortname: "AM",
    name: "Armenia",
    phonecode: "374"
  },
  {
    id: "12",
    sortname: "AW",
    name: "Aruba",
    phonecode: "297"
  },
  {
    id: "13",
    sortname: "AU",
    name: "Australia",
    phonecode: "61"
  },
  {
    id: "14",
    sortname: "AT",
    name: "Austria",
    phonecode: "43"
  },
  {
    id: "15",
    sortname: "AZ",
    name: "Azerbaijan",
    phonecode: "994"
  },
  {
    id: "16",
    sortname: "BS",
    name: "Bahamas The",
    phonecode: "1242"
  },
  {
    id: "17",
    sortname: "BH",
    name: "Bahrain",
    phonecode: "973"
  },
  {
    id: "18",
    sortname: "BD",
    name: "Bangladesh",
    phonecode: "880"
  },
  {
    id: "19",
    sortname: "BB",
    name: "Barbados",
    phonecode: "1246"
  },
  {
    id: "20",
    sortname: "BY",
    name: "Belarus",
    phonecode: "375"
  },
  {
    id: "21",
    sortname: "BE",
    name: "Belgium",
    phonecode: "32"
  },
  {
    id: "22",
    sortname: "BZ",
    name: "Belize",
    phonecode: "501"
  },
  {
    id: "23",
    sortname: "BJ",
    name: "Benin",
    phonecode: "229"
  },
  {
    id: "24",
    sortname: "BM",
    name: "Bermuda",
    phonecode: "1441"
  },
  {
    id: "25",
    sortname: "BT",
    name: "Bhutan",
    phonecode: "975"
  },
  {
    id: "26",
    sortname: "BO",
    name: "Bolivia",
    phonecode: "591"
  },
  {
    id: "27",
    sortname: "BA",
    name: "Bosnia and Herzegovina",
    phonecode: "387"
  },
  {
    id: "28",
    sortname: "BW",
    name: "Botswana",
    phonecode: "267"
  },
  {
    id: "29",
    sortname: "BV",
    name: "Bouvet Island",
    phonecode: "0"
  },
  {
    id: "30",
    sortname: "BR",
    name: "Brazil",
    phonecode: "55"
  },
  {
    id: "31",
    sortname: "IO",
    name: "British Indian Ocean Territory",
    phonecode: "246"
  },
  {
    id: "32",
    sortname: "BN",
    name: "Brunei",
    phonecode: "673"
  },
  {
    id: "33",
    sortname: "BG",
    name: "Bulgaria",
    phonecode: "359"
  },
  {
    id: "34",
    sortname: "BF",
    name: "Burkina Faso",
    phonecode: "226"
  },
  {
    id: "35",
    sortname: "BI",
    name: "Burundi",
    phonecode: "257"
  },
  {
    id: "36",
    sortname: "KH",
    name: "Cambodia",
    phonecode: "855"
  },
  {
    id: "37",
    sortname: "CM",
    name: "Cameroon",
    phonecode: "237"
  },
  {
    id: "38",
    sortname: "CA",
    name: "Canada",
    phonecode: "1"
  },
  {
    id: "39",
    sortname: "CV",
    name: "Cape Verde",
    phonecode: "238"
  },
  {
    id: "40",
    sortname: "KY",
    name: "Cayman Islands",
    phonecode: "1345"
  },
  {
    id: "41",
    sortname: "CF",
    name: "Central African Republic",
    phonecode: "236"
  },
  {
    id: "42",
    sortname: "TD",
    name: "Chad",
    phonecode: "235"
  },
  {
    id: "43",
    sortname: "CL",
    name: "Chile",
    phonecode: "56"
  },
  {
    id: "44",
    sortname: "CN",
    name: "China",
    phonecode: "86"
  },
  {
    id: "45",
    sortname: "CX",
    name: "Christmas Island",
    phonecode: "61"
  },
  {
    id: "46",
    sortname: "CC",
    name: "Cocos (Keeling) Islands",
    phonecode: "672"
  },
  {
    id: "47",
    sortname: "CO",
    name: "Colombia",
    phonecode: "57"
  },
  {
    id: "48",
    sortname: "KM",
    name: "Comoros",
    phonecode: "269"
  },
  {
    id: "49",
    sortname: "CG",
    name: "Congo",
    phonecode: "242"
  },
  {
    id: "50",
    sortname: "CD",
    name: "Congo The Democratic Republic Of The",
    phonecode: "242"
  },
  {
    id: "51",
    sortname: "CK",
    name: "Cook Islands",
    phonecode: "682"
  },
  {
    id: "52",
    sortname: "CR",
    name: "Costa Rica",
    phonecode: "506"
  },
  {
    id: "53",
    sortname: "CI",
    name: "Cote D''Ivoire (Ivory Coast)",
    phonecode: "225"
  },
  {
    id: "54",
    sortname: "HR",
    name: "Croatia (Hrvatska)",
    phonecode: "385"
  },
  {
    id: "55",
    sortname: "CU",
    name: "Cuba",
    phonecode: "53"
  },
  {
    id: "56",
    sortname: "CY",
    name: "Cyprus",
    phonecode: "357"
  },
  {
    id: "57",
    sortname: "CZ",
    name: "Czech Republic",
    phonecode: "420"
  },
  {
    id: "58",
    sortname: "DK",
    name: "Denmark",
    phonecode: "45"
  },
  {
    id: "59",
    sortname: "DJ",
    name: "Djibouti",
    phonecode: "253"
  },
  {
    id: "60",
    sortname: "DM",
    name: "Dominica",
    phonecode: "1767"
  },
  {
    id: "61",
    sortname: "DO",
    name: "Dominican Republic",
    phonecode: "1809"
  },
  {
    id: "62",
    sortname: "TP",
    name: "East Timor",
    phonecode: "670"
  },
  {
    id: "63",
    sortname: "EC",
    name: "Ecuador",
    phonecode: "593"
  },
  {
    id: "64",
    sortname: "EG",
    name: "Egypt",
    phonecode: "20"
  },
  {
    id: "65",
    sortname: "SV",
    name: "El Salvador",
    phonecode: "503"
  },
  {
    id: "66",
    sortname: "GQ",
    name: "Equatorial Guinea",
    phonecode: "240"
  },
  {
    id: "67",
    sortname: "ER",
    name: "Eritrea",
    phonecode: "291"
  },
  {
    id: "68",
    sortname: "EE",
    name: "Estonia",
    phonecode: "372"
  },
  {
    id: "69",
    sortname: "ET",
    name: "Ethiopia",
    phonecode: "251"
  },
  {
    id: "70",
    sortname: "XA",
    name: "External Territories of Australia",
    phonecode: "61"
  },
  {
    id: "71",
    sortname: "FK",
    name: "Falkland Islands",
    phonecode: "500"
  },
  {
    id: "72",
    sortname: "FO",
    name: "Faroe Islands",
    phonecode: "298"
  },
  {
    id: "73",
    sortname: "FJ",
    name: "Fiji Islands",
    phonecode: "679"
  },
  {
    id: "74",
    sortname: "FI",
    name: "Finland",
    phonecode: "358"
  },
  {
    id: "75",
    sortname: "FR",
    name: "France",
    phonecode: "33"
  },
  {
    id: "76",
    sortname: "GF",
    name: "French Guiana",
    phonecode: "594"
  },
  {
    id: "77",
    sortname: "PF",
    name: "French Polynesia",
    phonecode: "689"
  },
  {
    id: "78",
    sortname: "TF",
    name: "French Southern Territories",
    phonecode: "0"
  },
  {
    id: "79",
    sortname: "GA",
    name: "Gabon",
    phonecode: "241"
  },
  {
    id: "80",
    sortname: "GM",
    name: "Gambia The",
    phonecode: "220"
  },
  {
    id: "81",
    sortname: "GE",
    name: "Georgia",
    phonecode: "995"
  },
  {
    id: "82",
    sortname: "DE",
    name: "Germany",
    phonecode: "49"
  },
  {
    id: "83",
    sortname: "GH",
    name: "Ghana",
    phonecode: "233"
  },
  {
    id: "84",
    sortname: "GI",
    name: "Gibraltar",
    phonecode: "350"
  },
  {
    id: "85",
    sortname: "GR",
    name: "Greece",
    phonecode: "30"
  },
  {
    id: "86",
    sortname: "GL",
    name: "Greenland",
    phonecode: "299"
  },
  {
    id: "87",
    sortname: "GD",
    name: "Grenada",
    phonecode: "1473"
  },
  {
    id: "88",
    sortname: "GP",
    name: "Guadeloupe",
    phonecode: "590"
  },
  {
    id: "89",
    sortname: "GU",
    name: "Guam",
    phonecode: "1671"
  },
  {
    id: "90",
    sortname: "GT",
    name: "Guatemala",
    phonecode: "502"
  },
  {
    id: "91",
    sortname: "XU",
    name: "Guernsey and Alderney",
    phonecode: "44"
  },
  {
    id: "92",
    sortname: "GN",
    name: "Guinea",
    phonecode: "224"
  },
  {
    id: "93",
    sortname: "GW",
    name: "Guinea-Bissau",
    phonecode: "245"
  },
  {
    id: "94",
    sortname: "GY",
    name: "Guyana",
    phonecode: "592"
  },
  {
    id: "95",
    sortname: "HT",
    name: "Haiti",
    phonecode: "509"
  },
  {
    id: "96",
    sortname: "HM",
    name: "Heard and McDonald Islands",
    phonecode: "0"
  },
  {
    id: "97",
    sortname: "HN",
    name: "Honduras",
    phonecode: "504"
  },
  {
    id: "98",
    sortname: "HK",
    name: "Hong Kong S.A.R.",
    phonecode: "852"
  },
  {
    id: "99",
    sortname: "HU",
    name: "Hungary",
    phonecode: "36"
  },
  {
    id: "100",
    sortname: "IS",
    name: "Iceland",
    phonecode: "354"
  },
  {
    id: "101",
    sortname: "IN",
    name: "India",
    phonecode: "91"
  },
  {
    id: "102",
    sortname: "ID",
    name: "Indonesia",
    phonecode: "62"
  },
  {
    id: "103",
    sortname: "IR",
    name: "Iran",
    phonecode: "98"
  },
  {
    id: "104",
    sortname: "IQ",
    name: "Iraq",
    phonecode: "964"
  },
  {
    id: "105",
    sortname: "IE",
    name: "Ireland",
    phonecode: "353"
  },
  {
    id: "106",
    sortname: "IL",
    name: "Israel",
    phonecode: "972"
  },
  {
    id: "107",
    sortname: "IT",
    name: "Italy",
    phonecode: "39"
  },
  {
    id: "108",
    sortname: "JM",
    name: "Jamaica",
    phonecode: "1876"
  },
  {
    id: "109",
    sortname: "JP",
    name: "Japan",
    phonecode: "81"
  },
  {
    id: "110",
    sortname: "XJ",
    name: "Jersey",
    phonecode: "44"
  },
  {
    id: "111",
    sortname: "JO",
    name: "Jordan",
    phonecode: "962"
  },
  {
    id: "112",
    sortname: "KZ",
    name: "Kazakhstan",
    phonecode: "7"
  },
  {
    id: "113",
    sortname: "KE",
    name: "Kenya",
    phonecode: "254"
  },
  {
    id: "114",
    sortname: "KI",
    name: "Kiribati",
    phonecode: "686"
  },
  {
    id: "115",
    sortname: "KP",
    name: "Korea North",
    phonecode: "850"
  },
  {
    id: "116",
    sortname: "KR",
    name: "Korea South",
    phonecode: "82"
  },
  {
    id: "117",
    sortname: "KW",
    name: "Kuwait",
    phonecode: "965"
  },
  {
    id: "118",
    sortname: "KG",
    name: "Kyrgyzstan",
    phonecode: "996"
  },
  {
    id: "119",
    sortname: "LA",
    name: "Laos",
    phonecode: "856"
  },
  {
    id: "120",
    sortname: "LV",
    name: "Latvia",
    phonecode: "371"
  },
  {
    id: "121",
    sortname: "LB",
    name: "Lebanon",
    phonecode: "961"
  },
  {
    id: "122",
    sortname: "LS",
    name: "Lesotho",
    phonecode: "266"
  },
  {
    id: "123",
    sortname: "LR",
    name: "Liberia",
    phonecode: "231"
  },
  {
    id: "124",
    sortname: "LY",
    name: "Libya",
    phonecode: "218"
  },
  {
    id: "125",
    sortname: "LI",
    name: "Liechtenstein",
    phonecode: "423"
  },
  {
    id: "126",
    sortname: "LT",
    name: "Lithuania",
    phonecode: "370"
  },
  {
    id: "127",
    sortname: "LU",
    name: "Luxembourg",
    phonecode: "352"
  },
  {
    id: "128",
    sortname: "MO",
    name: "Macau S.A.R.",
    phonecode: "853"
  },
  {
    id: "129",
    sortname: "MK",
    name: "Macedonia",
    phonecode: "389"
  },
  {
    id: "130",
    sortname: "MG",
    name: "Madagascar",
    phonecode: "261"
  },
  {
    id: "131",
    sortname: "MW",
    name: "Malawi",
    phonecode: "265"
  },
  {
    id: "132",
    sortname: "MY",
    name: "Malaysia",
    phonecode: "60"
  },
  {
    id: "133",
    sortname: "MV",
    name: "Maldives",
    phonecode: "960"
  },
  {
    id: "134",
    sortname: "ML",
    name: "Mali",
    phonecode: "223"
  },
  {
    id: "135",
    sortname: "MT",
    name: "Malta",
    phonecode: "356"
  },
  {
    id: "136",
    sortname: "XM",
    name: "Man (Isle of)",
    phonecode: "44"
  },
  {
    id: "137",
    sortname: "MH",
    name: "Marshall Islands",
    phonecode: "692"
  },
  {
    id: "138",
    sortname: "MQ",
    name: "Martinique",
    phonecode: "596"
  },
  {
    id: "139",
    sortname: "MR",
    name: "Mauritania",
    phonecode: "222"
  },
  {
    id: "140",
    sortname: "MU",
    name: "Mauritius",
    phonecode: "230"
  },
  {
    id: "141",
    sortname: "YT",
    name: "Mayotte",
    phonecode: "269"
  },
  {
    id: "142",
    sortname: "MX",
    name: "Mexico",
    phonecode: "52"
  },
  {
    id: "143",
    sortname: "FM",
    name: "Micronesia",
    phonecode: "691"
  },
  {
    id: "144",
    sortname: "MD",
    name: "Moldova",
    phonecode: "373"
  },
  {
    id: "145",
    sortname: "MC",
    name: "Monaco",
    phonecode: "377"
  },
  {
    id: "146",
    sortname: "MN",
    name: "Mongolia",
    phonecode: "976"
  },
  {
    id: "147",
    sortname: "MS",
    name: "Montserrat",
    phonecode: "1664"
  },
  {
    id: "148",
    sortname: "MA",
    name: "Morocco",
    phonecode: "212"
  },
  {
    id: "149",
    sortname: "MZ",
    name: "Mozambique",
    phonecode: "258"
  },
  {
    id: "150",
    sortname: "MM",
    name: "Myanmar",
    phonecode: "95"
  },
  {
    id: "151",
    sortname: "NA",
    name: "Namibia",
    phonecode: "264"
  },
  {
    id: "152",
    sortname: "NR",
    name: "Nauru",
    phonecode: "674"
  },
  {
    id: "153",
    sortname: "NP",
    name: "Nepal",
    phonecode: "977"
  },
  {
    id: "154",
    sortname: "AN",
    name: "Netherlands Antilles",
    phonecode: "599"
  },
  {
    id: "155",
    sortname: "NL",
    name: "Netherlands",
    phonecode: "31"
  },
  {
    id: "156",
    sortname: "NC",
    name: "New Caledonia",
    phonecode: "687"
  },
  {
    id: "157",
    sortname: "NZ",
    name: "New Zealand",
    phonecode: "64"
  },
  {
    id: "158",
    sortname: "NI",
    name: "Nicaragua",
    phonecode: "505"
  },
  {
    id: "159",
    sortname: "NE",
    name: "Niger",
    phonecode: "227"
  },
  {
    id: "160",
    sortname: "NG",
    name: "Nigeria",
    phonecode: "234"
  },
  {
    id: "161",
    sortname: "NU",
    name: "Niue",
    phonecode: "683"
  },
  {
    id: "162",
    sortname: "NF",
    name: "Norfolk Island",
    phonecode: "672"
  },
  {
    id: "163",
    sortname: "MP",
    name: "Northern Mariana Islands",
    phonecode: "1670"
  },
  {
    id: "164",
    sortname: "NO",
    name: "Norway",
    phonecode: "47"
  },
  {
    id: "165",
    sortname: "OM",
    name: "Oman",
    phonecode: "968"
  },
  {
    id: "166",
    sortname: "PK",
    name: "Pakistan",
    phonecode: "92"
  },
  {
    id: "167",
    sortname: "PW",
    name: "Palau",
    phonecode: "680"
  },
  {
    id: "168",
    sortname: "PS",
    name: "Palestinian Territory Occupied",
    phonecode: "970"
  },
  {
    id: "169",
    sortname: "PA",
    name: "Panama",
    phonecode: "507"
  },
  {
    id: "170",
    sortname: "PG",
    name: "Papua new Guinea",
    phonecode: "675"
  },
  {
    id: "171",
    sortname: "PY",
    name: "Paraguay",
    phonecode: "595"
  },
  {
    id: "172",
    sortname: "PE",
    name: "Peru",
    phonecode: "51"
  },
  {
    id: "173",
    sortname: "PH",
    name: "Philippines",
    phonecode: "63"
  },
  {
    id: "174",
    sortname: "PN",
    name: "Pitcairn Island",
    phonecode: "0"
  },
  {
    id: "175",
    sortname: "PL",
    name: "Poland",
    phonecode: "48"
  },
  {
    id: "176",
    sortname: "PT",
    name: "Portugal",
    phonecode: "351"
  },
  {
    id: "177",
    sortname: "PR",
    name: "Puerto Rico",
    phonecode: "1787"
  },
  {
    id: "178",
    sortname: "QA",
    name: "Qatar",
    phonecode: "974"
  },
  {
    id: "179",
    sortname: "RE",
    name: "Reunion",
    phonecode: "262"
  },
  {
    id: "180",
    sortname: "RO",
    name: "Romania",
    phonecode: "40"
  },
  {
    id: "181",
    sortname: "RU",
    name: "Russia",
    phonecode: "70"
  },
  {
    id: "182",
    sortname: "RW",
    name: "Rwanda",
    phonecode: "250"
  },
  {
    id: "183",
    sortname: "SH",
    name: "Saint Helena",
    phonecode: "290"
  },
  {
    id: "184",
    sortname: "KN",
    name: "Saint Kitts And Nevis",
    phonecode: "1869"
  },
  {
    id: "185",
    sortname: "LC",
    name: "Saint Lucia",
    phonecode: "1758"
  },
  {
    id: "186",
    sortname: "PM",
    name: "Saint Pierre and Miquelon",
    phonecode: "508"
  },
  {
    id: "187",
    sortname: "VC",
    name: "Saint Vincent And The Grenadines",
    phonecode: "1784"
  },
  {
    id: "188",
    sortname: "WS",
    name: "Samoa",
    phonecode: "684"
  },
  {
    id: "189",
    sortname: "SM",
    name: "San Marino",
    phonecode: "378"
  },
  {
    id: "190",
    sortname: "ST",
    name: "Sao Tome and Principe",
    phonecode: "239"
  },
  {
    id: "191",
    sortname: "SA",
    name: "Saudi Arabia",
    phonecode: "966"
  },
  {
    id: "192",
    sortname: "SN",
    name: "Senegal",
    phonecode: "221"
  },
  {
    id: "193",
    sortname: "RS",
    name: "Serbia",
    phonecode: "381"
  },
  {
    id: "194",
    sortname: "SC",
    name: "Seychelles",
    phonecode: "248"
  },
  {
    id: "195",
    sortname: "SL",
    name: "Sierra Leone",
    phonecode: "232"
  },
  {
    id: "196",
    sortname: "SG",
    name: "Singapore",
    phonecode: "65"
  },
  {
    id: "197",
    sortname: "SK",
    name: "Slovakia",
    phonecode: "421"
  },
  {
    id: "198",
    sortname: "SI",
    name: "Slovenia",
    phonecode: "386"
  },
  {
    id: "199",
    sortname: "XG",
    name: "Smaller Territories of the UK",
    phonecode: "44"
  },
  {
    id: "200",
    sortname: "SB",
    name: "Solomon Islands",
    phonecode: "677"
  },
  {
    id: "201",
    sortname: "SO",
    name: "Somalia",
    phonecode: "252"
  },
  {
    id: "202",
    sortname: "ZA",
    name: "South Africa",
    phonecode: "27"
  },
  {
    id: "203",
    sortname: "GS",
    name: "South Georgia",
    phonecode: "0"
  },
  {
    id: "204",
    sortname: "SS",
    name: "South Sudan",
    phonecode: "211"
  },
  {
    id: "205",
    sortname: "ES",
    name: "Spain",
    phonecode: "34"
  },
  {
    id: "206",
    sortname: "LK",
    name: "Sri Lanka",
    phonecode: "94"
  },
  {
    id: "207",
    sortname: "SD",
    name: "Sudan",
    phonecode: "249"
  },
  {
    id: "208",
    sortname: "SR",
    name: "Suriname",
    phonecode: "597"
  },
  {
    id: "209",
    sortname: "SJ",
    name: "Svalbard And Jan Mayen Islands",
    phonecode: "47"
  },
  {
    id: "210",
    sortname: "SZ",
    name: "Swaziland",
    phonecode: "268"
  },
  {
    id: "211",
    sortname: "SE",
    name: "Sweden",
    phonecode: "46"
  },
  {
    id: "212",
    sortname: "CH",
    name: "Switzerland",
    phonecode: "41"
  },
  {
    id: "213",
    sortname: "SY",
    name: "Syria",
    phonecode: "963"
  },
  {
    id: "214",
    sortname: "TW",
    name: "Taiwan",
    phonecode: "886"
  },
  {
    id: "215",
    sortname: "TJ",
    name: "Tajikistan",
    phonecode: "992"
  },
  {
    id: "216",
    sortname: "TZ",
    name: "Tanzania",
    phonecode: "255"
  },
  {
    id: "217",
    sortname: "TH",
    name: "Thailand",
    phonecode: "66"
  },
  {
    id: "218",
    sortname: "TG",
    name: "Togo",
    phonecode: "228"
  },
  {
    id: "219",
    sortname: "TK",
    name: "Tokelau",
    phonecode: "690"
  },
  {
    id: "220",
    sortname: "TO",
    name: "Tonga",
    phonecode: "676"
  },
  {
    id: "221",
    sortname: "TT",
    name: "Trinidad And Tobago",
    phonecode: "1868"
  },
  {
    id: "222",
    sortname: "TN",
    name: "Tunisia",
    phonecode: "216"
  },
  {
    id: "223",
    sortname: "TR",
    name: "Turkey",
    phonecode: "90"
  },
  {
    id: "224",
    sortname: "TM",
    name: "Turkmenistan",
    phonecode: "7370"
  },
  {
    id: "225",
    sortname: "TC",
    name: "Turks And Caicos Islands",
    phonecode: "1649"
  },
  {
    id: "226",
    sortname: "TV",
    name: "Tuvalu",
    phonecode: "688"
  },
  {
    id: "227",
    sortname: "UG",
    name: "Uganda",
    phonecode: "256"
  },
  {
    id: "228",
    sortname: "UA",
    name: "Ukraine",
    phonecode: "380"
  },
  {
    id: "229",
    sortname: "AE",
    name: "United Arab Emirates",
    phonecode: "971"
  },
  {
    id: "230",
    sortname: "GB",
    name: "United Kingdom",
    phonecode: "44"
  },
  {
    id: "231",
    sortname: "US",
    name: "United States",
    phonecode: "1"
  },
  {
    id: "232",
    sortname: "UM",
    name: "United States Minor Outlying Islands",
    phonecode: "1"
  },
  {
    id: "233",
    sortname: "UY",
    name: "Uruguay",
    phonecode: "598"
  },
  {
    id: "234",
    sortname: "UZ",
    name: "Uzbekistan",
    phonecode: "998"
  },
  {
    id: "235",
    sortname: "VU",
    name: "Vanuatu",
    phonecode: "678"
  },
  {
    id: "236",
    sortname: "VA",
    name: "Vatican City State (Holy See)",
    phonecode: "39"
  },
  {
    id: "237",
    sortname: "VE",
    name: "Venezuela",
    phonecode: "58"
  },
  {
    id: "238",
    sortname: "VN",
    name: "Vietnam",
    phonecode: "84"
  },
  {
    id: "239",
    sortname: "VG",
    name: "Virgin Islands (British)",
    phonecode: "1284"
  },
  {
    id: "240",
    sortname: "VI",
    name: "Virgin Islands (US)",
    phonecode: "1340"
  },
  {
    id: "241",
    sortname: "WF",
    name: "Wallis And Futuna Islands",
    phonecode: "681"
  },
  {
    id: "242",
    sortname: "EH",
    name: "Western Sahara",
    phonecode: "212"
  },
  {
    id: "243",
    sortname: "YE",
    name: "Yemen",
    phonecode: "967"
  },
  {
    id: "244",
    sortname: "YU",
    name: "Yugoslavia",
    phonecode: "38"
  },
  {
    id: "245",
    sortname: "ZM",
    name: "Zambia",
    phonecode: "260"
  },
  {
    id: "246",
    sortname: "ZW",
    name: "Zimbabwe",
    phonecode: "263"
  }
];
export const subscriptionTypes = [
  {
    value: null,
    text: "Select subscription type"
  },
  {
    value: BASIC,
    text: "Basic"
  },
  {
    value: BUSINESS,
    text: "Business"
  },
  {
    value: ENTERPRISE,
    text: "Enterprise"
  },
  {
    value: UNLIMITED,
    text: "Unlimited"
  }
];
export const months = [
  { value: "JAN", id: 1 },
  { value: "FEB", id: 2 },
  { value: "MAR", id: 3 },
  { value: "APR", id: 4 },
  { value: "MAY", id: 5 },
  { value: "JUN", id: 6 },
  { value: "JUL", id: 7 },
  { value: "AUG", id: 8 },
  { value: "SEP", id: 9 },
  { value: "OCT", id: 10 },
  { value: "NOV", id: 11 },
  { value: "DEC", id: 12 }
];

// Team Job Titles
export const TEAM_JOB_TITLES = [
  {
    value: "EA_EU",
    text: "Executive Assistant EU"
  },
  {
    value: "EA_US",
    text: "Executive Assistant US"
  },
  {
    value: "ADMIN",
    text: "Administrator"
  },
  {
    value: "OWNER",
    text: "Owner"
  }
];

// Routes an Owner is allowed to reach. Allowlist rather than denylist so a
// newly added route is closed to Owners until it is considered explicitly.
// Owners get Customers, Team, Resources and Reports only - no Handover,
// Tasks, Search, Notifications, Messages or Admin.
export const OWNER_ALLOWED_ROUTES = [
  // Auth / chrome
  "Login",
  "ForgotPassword",
  "ResetPassword",
  "AzureCallback",
  "ProfileSettings",
  "404",
  "403",
  // Customers (read-only)
  "DedicatedCustomers",
  "CustomerDetails",
  "ViewEditPreference",
  // Team
  "ViewPADirectory",
  "PADetails",
  // Resources
  "Resources",
  "ViewCategory",
  // Reports
  "ReportsList",
  "ReportDetails"
];

// Forms
export const ONBOARDING_INTAKE = "CUSTOMER_ONBOARDING_INTAKE";
export const QUESTION_TYPE_TEXT = "TEXT";

// Internal customer

export const internalCustomerEmailSet = new Set([
  "headroom.tasks@iloveheadroom.com",
])

export const ACCEPTED = "accepted";
export const REJECTED = "rejected";
export const NOACTION = "noaction";
// Profile Types
export const profileTypes = [
  {
    value: "A",
    text: "A",
    id: 0
  },
  {
    value: "B",
    text: "B",
    id: 1
  },
  {
    value: "C",
    text: "C",
    id: 2
  },
  {
    value: "D",
    text: "D",
    id: 3
  }
];

//Timezone

export const timeZones = [
  { value: null, text: "Select timezone" },
  {
    value: { id: 0, timeZone: "GMT -11:00", tzCode: "Pacific/Niue" },
    text: "(GMT-11:00) Niue"
  },
  {
    value: { id: 1, timeZone: "GMT -11:00", tzCode: "Pacific/Pago_Pago" },
    text: "(GMT-11:00) Pago Pago"
  },
  {
    value: { id: 2, timeZone: "GMT -10:00", tzCode: "Pacific/Honolulu" },
    text: "(GMT-10:00) Hawaii Time"
  },
  {
    value: { id: 3, timeZone: "GMT -10:00", tzCode: "Pacific/Rarotonga" },
    text: "(GMT-10:00) Rarotonga"
  },
  {
    value: { id: 4, timeZone: "GMT -10:00", tzCode: "Pacific/Tahiti" },
    text: "(GMT-10:00) Tahiti"
  },
  {
    value: { id: 5, timeZone: "GMT -09:30", tzCode: "Pacific/Marquesas" },
    text: "(GMT-09:30) Marquesas"
  },
  {
    value: { id: 6, timeZone: "GMT -09:00", tzCode: "America/Anchorage" },
    text: "(GMT-09:00) Alaska Time"
  },
  {
    value: { id: 7, timeZone: "GMT -09:00", tzCode: "Pacific/Gambier" },
    text: "(GMT-09:00) Gambier"
  },
  {
    value: { id: 8, timeZone: "GMT -08:00", tzCode: "America/Los_Angeles" },
    text: "(GMT-08:00) Pacific Time"
  },
  {
    value: { id: 9, timeZone: "GMT -08:00", tzCode: "America/Tijuana" },
    text: "(GMT-08:00) Pacific Time - Tijuana"
  },
  {
    value: { id: 10, timeZone: "GMT -08:00", tzCode: "America/Vancouver" },
    text: "(GMT-08:00) Pacific Time - Vancouver"
  },
  {
    value: { id: 11, timeZone: "GMT -08:00", tzCode: "Pacific/Pitcairn" },
    text: "(GMT-08:00) Pacific Time - Whitehorse"
  },
  {
    value: { id: 12, timeZone: "GMT -08:00", tzCode: "Pacific/Pitcairn" },
    text: "(GMT-08:00) Pitcairn"
  },
  {
    value: { id: 13, timeZone: "GMT -07:00", tzCode: "America/Denver" },
    text: "(GMT-07:00) Mountain Time"
  },
  {
    value: { id: 14, timeZone: "GMT -07:00", tzCode: "America/Phoenix" },
    text: "(GMT-07:00) Mountain Time - Arizona"
  },
  {
    value: { id: 15, timeZone: "GMT -07:00", tzCode: "America/Mazatlan" },
    text: "(GMT-07:00) Mountain Time - Chihuahua, Mazatlan"
  },
  {
    value: { id: 16, timeZone: "GMT -07:00", tzCode: "America/Dawson_Creek" },
    text: "(GMT-07:00) Mountain Time - Dawson Creek"
  },
  {
    value: { id: 17, timeZone: "GMT -07:00", tzCode: "America/Edmonton" },
    text: "(GMT-07:00) Mountain Time - Edmonton"
  },
  {
    value: { id: 18, timeZone: "GMT -07:00", tzCode: "America/Hermosillo" },
    text: "(GMT-07:00) Mountain Time - Hermosillo"
  },
  {
    value: { id: 19, timeZone: "GMT -07:00", tzCode: "America/Yellowknife" },
    text: "(GMT-07:00) Mountain Time - Yellowknife"
  },
  {
    value: { id: 20, timeZone: "GMT -06:00", tzCode: "America/Belize" },
    text: "(GMT-06:00) Belize"
  },
  {
    value: { id: 21, timeZone: "GMT -06:00", tzCode: "America/Chicago" },
    text: "(GMT-06:00) Central Time"
  },
  {
    value: { id: 22, timeZone: "GMT -06:00", tzCode: "America/Mexico_City" },
    text: "(GMT-06:00) Central Time - Mexico City"
  },
  {
    value: { id: 23, timeZone: "GMT -06:00", tzCode: "America/Regina" },
    text: "(GMT-06:00) Central Time - Regina"
  },
  {
    value: { id: 24, timeZone: "GMT -06:00", tzCode: "America/Tegucigalpa" },
    text: "(GMT-06:00) Central Time - Tegucigalpa"
  },
  {
    value: { id: 25, timeZone: "GMT -06:00", tzCode: "America/Winnipeg" },
    text: "(GMT-06:00) Central Time - Winnipeg"
  },
  {
    value: { id: 26, timeZone: "GMT -06:00", tzCode: "America/Costa_Rica" },
    text: "(GMT-06:00) Costa Rica"
  },
  {
    value: { id: 27, timeZone: "GMT -06:00", tzCode: "America/El_Salvador" },
    text: "(GMT-06:00) El Salvador"
  },
  {
    value: { id: 28, timeZone: "GMT -06:00", tzCode: "Pacific/Galapagos" },
    text: "(GMT-06:00) Galapagos"
  },
  {
    value: { id: 29, timeZone: "GMT -06:00", tzCode: "America/Guatemala" },
    text: "(GMT-06:00) Guatemala"
  },
  {
    value: { id: 30, timeZone: "GMT -06:00", tzCode: "America/Managua" },
    text: "(GMT-06:00) Managua"
  },
  {
    value: { id: 31, timeZone: "GMT -05:00", tzCode: "America/Cancun" },
    text: "(GMT-05:00) America Cancun"
  },
  {
    value: { id: 32, timeZone: "GMT -05:00", tzCode: "America/Bogota" },
    text: "(GMT-05:00) Bogota"
  },
  {
    value: { id: 33, timeZone: "GMT -05:00", tzCode: "Pacific/Easter" },
    text: "(GMT-05:00) Easter Island"
  },
  {
    value: { id: 34, timeZone: "GMT -05:00", tzCode: "America/New_York" },
    text: "(GMT-05:00) Eastern Time"
  },
  {
    value: { id: 35, timeZone: "GMT -05:00", tzCode: "America/Iqaluit" },
    text: "(GMT-05:00) Eastern Time - Iqaluit"
  },
  {
    value: { id: 36, timeZone: "GMT -05:00", tzCode: "America/Toronto" },
    text: "(GMT-05:00) Eastern Time - Toronto"
  },
  {
    value: { id: 37, timeZone: "GMT -05:00", tzCode: "America/Guayaquil" },
    text: "(GMT-05:00) Guayaquil"
  },
  {
    value: { id: 38, timeZone: "GMT -05:00", tzCode: "America/Havana" },
    text: "(GMT-05:00) Havana"
  },
  {
    value: { id: 39, timeZone: "GMT -05:00", tzCode: "America/Jamaica" },
    text: "(GMT-05:00) Jamaica"
  },
  {
    value: { id: 40, timeZone: "GMT -05:00", tzCode: "America/Lima" },
    text: "(GMT-05:00) Lima"
  },
  {
    value: { id: 41, timeZone: "GMT -05:00", tzCode: "America/Nassau" },
    text: "(GMT-05:00) Nassau"
  },
  {
    value: { id: 42, timeZone: "GMT -05:00", tzCode: "America/Panama" },
    text: "(GMT-05:00) Panama"
  },
  {
    value: { id: 43, timeZone: "GMT -05:00", tzCode: "America/Port-au-Prince" },
    text: "(GMT-05:00) Port-au-Prince"
  },
  {
    value: { id: 44, timeZone: "GMT -05:00", tzCode: "America/Rio_Branco" },
    text: "(GMT-05:00) Rio Branco"
  },
  {
    value: { id: 45, timeZone: "GMT -04:00", tzCode: "America/Halifax" },
    text: "(GMT-04:00) Atlantic Time - Halifax"
  },
  {
    value: { id: 46, timeZone: "GMT -04:00", tzCode: "America/Barbados" },
    text: "(GMT-04:00) Barbados"
  },
  {
    value: { id: 47, timeZone: "GMT -04:00", tzCode: "Atlantic/Bermuda" },
    text: "(GMT-04:00) Bermuda"
  },
  {
    value: { id: 48, timeZone: "GMT -04:00", tzCode: "America/Boa_Vista" },
    text: "(GMT-04:00) Boa Vista"
  },
  {
    value: { id: 49, timeZone: "GMT -04:00", tzCode: "America/Caracas" },
    text: "(GMT-04:00) Caracas"
  },
  {
    value: { id: 50, timeZone: "GMT -04:00", tzCode: "America/Curacao" },
    text: "(GMT-04:00) Curacao"
  },
  {
    value: { id: 51, timeZone: "GMT -04:00", tzCode: "America/Grand_Turk" },
    text: "(GMT-04:00) Grand Turk"
  },
  {
    value: { id: 52, timeZone: "GMT -04:00", tzCode: "America/Guyana" },
    text: "(GMT-04:00) Guyana"
  },
  {
    value: { id: 53, timeZone: "GMT -04:00", tzCode: "America/La_Paz" },
    text: "(GMT-04:00) La Paz"
  },
  {
    value: { id: 54, timeZone: "GMT -04:00", tzCode: "America/Manaus" },
    text: "(GMT-04:00) Manaus"
  },
  {
    value: { id: 55, timeZone: "GMT -04:00", tzCode: "America/Martinique" },
    text: "(GMT-04:00) Martinique"
  },
  {
    value: { id: 56, timeZone: "GMT -04:00", tzCode: "America/Port_of_Spain" },
    text: "(GMT-04:00) Port of Spain"
  },
  {
    value: { id: 57, timeZone: "GMT -04:00", tzCode: "America/Porto_Velho" },
    text: "(GMT-04:00) Porto Velho"
  },
  {
    value: { id: 58, timeZone: "GMT -04:00", tzCode: "America/Puerto_Rico" },
    text: "(GMT-04:00) Puerto Rico"
  },
  {
    value: { id: 59, timeZone: "GMT -04:00", tzCode: "America/Santo_Domingo" },
    text: "(GMT-04:00) Santo Domingo"
  },
  {
    value: { id: 60, timeZone: "GMT -04:00", tzCode: "America/Thule" },
    text: "(GMT-04:00) Thule"
  },
  {
    value: { id: 61, timeZone: "GMT -03:30", tzCode: "America/St_Johns" },
    text: "(GMT-03:30) Newfoundland Time - St. Johns"
  },
  {
    value: { id: 62, timeZone: "GMT -03:00", tzCode: "America/Araguaina" },
    text: "(GMT-03:00) Araguaina"
  },
  {
    value: { id: 63, timeZone: "GMT -03:00", tzCode: "America/Asuncion" },
    text: "(GMT-03:00) Asuncion"
  },
  {
    value: { id: 64, timeZone: "GMT -03:00", tzCode: "America/Belem" },
    text: "(GMT-03:00) Belem"
  },
  {
    value: {
      id: 65,
      timeZone: "GMT -03:00",
      tzCode: "America/Argentina/Buenos_Aires"
    },
    text: "(GMT-03:00) Buenos Aires"
  },
  {
    value: { id: 66, timeZone: "GMT -03:00", tzCode: "America/Campo_Grande" },
    text: "(GMT-03:00) Campo Grande"
  },
  {
    value: { id: 67, timeZone: "GMT -03:00", tzCode: "America/Cayenne" },
    text: "(GMT-03:00) Cayenne"
  },
  {
    value: { id: 68, timeZone: "GMT -03:00", tzCode: "America/Cuiaba" },
    text: "(GMT-03:00) Cuiaba"
  },
  {
    value: { id: 69, timeZone: "GMT -03:00", tzCode: "America/Fortaleza" },
    text: "(GMT-03:00) Fortaleza"
  },
  {
    value: { id: 70, timeZone: "GMT -03:00", tzCode: "America/Godthab" },
    text: "(GMT-03:00) Godthab"
  },
  {
    value: { id: 71, timeZone: "GMT -03:00", tzCode: "America/Maceio" },
    text: "(GMT-03:00) Maceio"
  },
  {
    value: { id: 72, timeZone: "GMT -03:00", tzCode: "America/Miquelon" },
    text: "(GMT-03:00) Miquelon"
  },
  {
    value: { id: 73, timeZone: "GMT -03:00", tzCode: "America/Montevideo" },
    text: "(GMT-03:00) Montevideo"
  },
  {
    value: { id: 74, timeZone: "GMT -03:00", tzCode: "Antarctica/Palmer" },
    text: "(GMT-03:00) Palmer"
  },
  {
    value: { id: 75, timeZone: "GMT -03:00", tzCode: "America/Paramaribo" },
    text: "(GMT-03:00) Paramaribo"
  },
  {
    value: { id: 76, timeZone: "GMT -03:00", tzCode: "America/Punta_Arenas" },
    text: "(GMT-03:00) Punta Arenas"
  },
  {
    value: { id: 77, timeZone: "GMT -03:00", tzCode: "America/Recife" },
    text: "(GMT-03:00) Recife"
  },
  {
    value: { id: 78, timeZone: "GMT -03:00", tzCode: "Antarctica/Rothera" },
    text: "(GMT-03:00) Rothera"
  },
  {
    value: { id: 79, timeZone: "GMT -03:00", tzCode: "America/Bahia" },
    text: "(GMT-03:00) Salvador"
  },
  {
    value: { id: 80, timeZone: "GMT -03:00", tzCode: "America/Santiago" },
    text: "(GMT-03:00) Santiago"
  },
  {
    value: { id: 81, timeZone: "GMT -03:00", tzCode: "Atlantic/Stanley" },
    text: "(GMT-03:00) Stanley"
  },
  {
    value: { id: 82, timeZone: "GMT -02:00", tzCode: "America/Noronha" },
    text: "(GMT-02:00) Noronha"
  },
  {
    value: { id: 83, timeZone: "GMT -02:00", tzCode: "America/Sao_Paulo" },
    text: "(GMT-02:00) Sao Paulo"
  },
  {
    value: { id: 84, timeZone: "GMT -02:00", tzCode: "Atlantic/South_Georgia" },
    text: "(GMT-02:00) South Georgia"
  },
  {
    value: { id: 85, timeZone: "GMT -01:00", tzCode: "Atlantic/Azores" },
    text: "(GMT-01:00) Azores"
  },
  {
    value: { id: 86, timeZone: "GMT -01:00", tzCode: "Atlantic/Cape_Verde" },
    text: "(GMT-01:00) Cape Verde"
  },
  {
    value: { id: 87, timeZone: "GMT -01:00", tzCode: "America/Scoresbysund" },
    text: "(GMT-01:00) Scoresbysund"
  },
  {
    value: { id: 88, timeZone: "GMT +00:00", tzCode: "Africa/Abidjan" },
    text: "(GMT+00:00) Abidjan"
  },
  {
    value: { id: 89, timeZone: "GMT +00:00", tzCode: "Africa/Accra" },
    text: "(GMT+00:00) Accra"
  },
  {
    value: { id: 90, timeZone: "GMT +00:00", tzCode: "Africa/Bissau" },
    text: "(GMT+00:00) Bissau"
  },
  {
    value: { id: 91, timeZone: "GMT +00:00", tzCode: "Atlantic/Canary" },
    text: "(GMT+00:00) Canary Islands"
  },
  {
    value: { id: 92, timeZone: "GMT +00:00", tzCode: "Africa/Casablanca" },
    text: "(GMT+00:00) Casablanca"
  },
  {
    value: { id: 93, timeZone: "GMT +00:00", tzCode: "America/Danmarkshavn" },
    text: "(GMT+00:00) Danmarkshavn"
  },
  {
    value: { id: 94, timeZone: "GMT +00:00", tzCode: "Europe/Dublin" },
    text: "(GMT+00:00) Dublin"
  },
  {
    value: { id: 95, timeZone: "GMT +00:00", tzCode: "Africa/El_Aaiun" },
    text: "(GMT+00:00) El Aaiun"
  },
  {
    value: { id: 96, timeZone: "GMT +00:00", tzCode: "Atlantic/Faroe" },
    text: "(GMT+00:00) Faeroe"
  },
  {
    value: { id: 97, timeZone: "GMT +00:00", tzCode: "Etc/GMT" },
    text: "(GMT+00:00) GMT (no daylight saving)"
  },
  {
    value: { id: 98, timeZone: "GMT +00:00", tzCode: "Europe/Lisbon" },
    text: "(GMT+00:00) Lisbon"
  },
  {
    value: { id: 99, timeZone: "GMT +00:00", tzCode: "Europe/London" },
    text: "(GMT+00:00) London"
  },
  {
    value: { id: 100, timeZone: "GMT +00:00", tzCode: "Africa/Monrovia" },
    text: "(GMT+00:00) Monrovia"
  },
  {
    value: { id: 101, timeZone: "GMT +00:00", tzCode: "Atlantic/Reykjavik" },
    text: "(GMT+00:00) Reykjavik"
  },
  {
    value: { id: 102, timeZone: "GMT +01:00", tzCode: "Africa/Algiers" },
    text: "(GMT+01:00) Algiers"
  },
  {
    value: { id: 103, timeZone: "GMT +01:00", tzCode: "Europe/Amsterdam" },
    text: "(GMT+01:00) Amsterdam"
  },
  {
    value: { id: 104, timeZone: "GMT +01:00", tzCode: "Europe/Andorra" },
    text: "(GMT+01:00) Andorra"
  },
  {
    value: { id: 105, timeZone: "GMT +01:00", tzCode: "Europe/Berlin" },
    text: "(GMT+01:00) Berlin"
  },
  {
    value: { id: 106, timeZone: "GMT +01:00", tzCode: "Europe/Brussels" },
    text: "(GMT+01:00) Brussels"
  },
  {
    value: { id: 107, timeZone: "GMT +01:00", tzCode: "Europe/Budapest" },
    text: "(GMT+01:00) Budapest"
  },
  {
    value: { id: 108, timeZone: "GMT +01:00", tzCode: "Europe/Belgrade" },
    text: "(GMT+01:00) Central European Time - Belgrade"
  },
  {
    value: { id: 109, timeZone: "GMT +01:00", tzCode: "Europe/Prague" },
    text: "(GMT+01:00) Central European Time - Prague"
  },
  {
    value: { id: 110, timeZone: "GMT +01:00", tzCode: "Africa/Ceuta" },
    text: "(GMT+01:00) Ceuta"
  },
  {
    value: { id: 111, timeZone: "GMT +01:00", tzCode: "Europe/Copenhagen" },
    text: "(GMT+01:00) Copenhagen"
  },
  {
    value: { id: 112, timeZone: "GMT +01:00", tzCode: "Europe/Gibraltar" },
    text: "(GMT+01:00) Gibraltar"
  },
  {
    value: { id: 113, timeZone: "GMT +01:00", tzCode: "Africa/Lagos" },
    text: "(GMT+01:00) Lagos"
  },
  {
    value: { id: 114, timeZone: "GMT +01:00", tzCode: "Europe/Luxembourg" },
    text: "(GMT+01:00) Luxembourg"
  },
  {
    value: { id: 115, timeZone: "GMT +01:00", tzCode: "Europe/Madrid" },
    text: "(GMT+01:00) Madrid"
  },
  {
    value: { id: 116, timeZone: "GMT +01:00", tzCode: "Europe/Malta" },
    text: "(GMT+01:00) Malta"
  },
  {
    value: { id: 117, timeZone: "GMT +01:00", tzCode: "Europe/Monaco" },
    text: "(GMT+01:00) Monaco"
  },
  {
    value: { id: 118, timeZone: "GMT +01:00", tzCode: "Africa/Ndjamena" },
    text: "(GMT+01:00) Ndjamena"
  },
  {
    value: { id: 119, timeZone: "GMT +01:00", tzCode: "Europe/Oslo" },
    text: "(GMT+01:00) Oslo"
  },
  {
    value: { id: 120, timeZone: "GMT +01:00", tzCode: "Europe/Paris" },
    text: "(GMT+01:00) Paris"
  },
  {
    value: { id: 121, timeZone: "GMT +01:00", tzCode: "Europe/Rome" },
    text: "(GMT+01:00) Rome"
  },
  {
    value: { id: 122, timeZone: "GMT +01:00", tzCode: "Europe/Stockholm" },
    text: "(GMT+01:00) Stockholm"
  },
  {
    value: { id: 123, timeZone: "GMT +01:00", tzCode: "Europe/Tirane" },
    text: "(GMT+01:00) Tirane"
  },
  {
    value: { id: 124, timeZone: "GMT +01:00", tzCode: "Africa/Tunis" },
    text: "(GMT+01:00) Tunis"
  },
  {
    value: { id: 125, timeZone: "GMT +01:00", tzCode: "Europe/Vienna" },
    text: "(GMT+01:00) Vienna"
  },
  {
    value: { id: 126, timeZone: "GMT +01:00", tzCode: "Europe/Warsaw" },
    text: "(GMT+01:00) Warsaw"
  },
  {
    value: { id: 127, timeZone: "GMT +01:00", tzCode: "Europe/Zurich" },
    text: "(GMT+01:00) Zurich"
  },
  {
    value: { id: 128, timeZone: "GMT +02:00", tzCode: "Asia/Amman" },
    text: "(GMT+02:00) Amman"
  },
  {
    value: { id: 129, timeZone: "GMT +02:00", tzCode: "Europe/Athens" },
    text: "(GMT+02:00) Athens"
  },
  {
    value: { id: 130, timeZone: "GMT +02:00", tzCode: "Asia/Beirut" },
    text: "(GMT+02:00) Beirut"
  },
  {
    value: { id: 131, timeZone: "GMT +02:00", tzCode: "Europe/Bucharest" },
    text: "(GMT+02:00) Bucharest"
  },
  {
    value: { id: 132, timeZone: "GMT +02:00", tzCode: "Africa/Cairo" },
    text: "(GMT+02:00) Cairo"
  },
  {
    value: { id: 133, timeZone: "GMT +02:00", tzCode: "Europe/Chisinau" },
    text: "(GMT+02:00) Chisinau"
  },
  {
    value: { id: 134, timeZone: "GMT +02:00", tzCode: "Asia/Damascus" },
    text: "(GMT+02:00) Damascus"
  },
  {
    value: { id: 135, timeZone: "GMT +02:00", tzCode: "Asia/Gaza" },
    text: "(GMT+02:00) Gaza"
  },
  {
    value: { id: 136, timeZone: "GMT +02:00", tzCode: "Europe/Helsinki" },
    text: "(GMT+02:00) Helsinki"
  },
  {
    value: { id: 137, timeZone: "GMT +02:00", tzCode: "Asia/Jerusalem" },
    text: "(GMT+02:00) Jerusalem"
  },
  {
    value: { id: 138, timeZone: "GMT +02:00", tzCode: "Africa/Johannesburg" },
    text: "(GMT+02:00) Johannesburg"
  },
  {
    value: { id: 139, timeZone: "GMT +02:00", tzCode: "Africa/Khartoum" },
    text: "(GMT+02:00) Khartoum"
  },
  {
    value: { id: 140, timeZone: "GMT +02:00", tzCode: "Europe/Kiev" },
    text: "(GMT+02:00) Kiev"
  },
  {
    value: { id: 141, timeZone: "GMT +02:00", tzCode: "Africa/Maputo" },
    text: "(GMT+02:00) Maputo"
  },
  {
    value: { id: 142, timeZone: "GMT +02:00", tzCode: "Europe/Kaliningrad" },
    text: "(GMT+02:00) Moscow-01 - Kaliningrad"
  },
  {
    value: { id: 143, timeZone: "GMT +02:00", tzCode: "Asia/Nicosia" },
    text: "(GMT+02:00) Nicosia"
  },
  {
    value: { id: 144, timeZone: "GMT +02:00", tzCode: "Europe/Riga" },
    text: "(GMT+02:00) Riga"
  },
  {
    value: { id: 145, timeZone: "GMT +02:00", tzCode: "Europe/Sofia" },
    text: "(GMT+02:00) Sofia"
  },
  {
    value: { id: 146, timeZone: "GMT +02:00", tzCode: "Europe/Tallinn" },
    text: "(GMT+02:00) Tallinn"
  },
  {
    value: { id: 147, timeZone: "GMT +02:00", tzCode: "Africa/Tripoli" },
    text: "(GMT+02:00) Tripoli"
  },
  {
    value: { id: 148, timeZone: "GMT +02:00", tzCode: "Europe/Vilnius" },
    text: "(GMT+02:00) Vilnius"
  },
  {
    value: { id: 149, timeZone: "GMT +02:00", tzCode: "Africa/Windhoek" },
    text: "(GMT+02:00) Windhoek"
  },
  {
    value: { id: 150, timeZone: "GMT +03:00", tzCode: "Asia/Baghdad" },
    text: "(GMT+03:00) Baghdad"
  },
  {
    value: { id: 151, timeZone: "GMT +03:00", tzCode: "Europe/Istanbul" },
    text: "(GMT+03:00) Istanbul"
  },
  {
    value: { id: 152, timeZone: "GMT +03:00", tzCode: "Europe/Minsk" },
    text: "(GMT+03:00) Minsk"
  },
  {
    value: { id: 153, timeZone: "GMT +03:00", tzCode: "Europe/Moscow" },
    text: "(GMT+03:00) Moscow+00 - Moscow"
  },
  {
    value: { id: 154, timeZone: "GMT +03:00", tzCode: "Africa/Nairobi" },
    text: "(GMT+03:00) Nairobi"
  },
  {
    value: { id: 155, timeZone: "GMT +03:00", tzCode: "Asia/Qatar" },
    text: "(GMT+03:00) Qatar"
  },
  {
    value: { id: 156, timeZone: "GMT +03:00", tzCode: "Asia/Riyadh" },
    text: "(GMT+03:00) Riyadh"
  },
  {
    value: { id: 157, timeZone: "GMT +03:00", tzCode: "Antarctica/Syowa" },
    text: "(GMT+03:00) Syowa"
  },
  {
    value: { id: 158, timeZone: "GMT +03:30", tzCode: "Asia/Tehran" },
    text: "(GMT+03:30) Tehran"
  },
  {
    value: { id: 159, timeZone: "GMT +04:00", tzCode: "Asia/Baku" },
    text: "(GMT+04:00) Baku"
  },
  {
    value: { id: 160, timeZone: "GMT +04:00", tzCode: "Asia/Dubai" },
    text: "(GMT+04:00) Dubai"
  },
  {
    value: { id: 161, timeZone: "GMT +04:00", tzCode: "Indian/Mahe" },
    text: "(GMT+04:00) Mahe"
  },
  {
    value: { id: 162, timeZone: "GMT +04:00", tzCode: "Indian/Mauritius" },
    text: "(GMT+04:00) Mauritius"
  },
  {
    value: { id: 163, timeZone: "GMT +04:00", tzCode: "Europe/Samara" },
    text: "(GMT+04:00) Moscow+01 - Samara"
  },
  {
    value: { id: 164, timeZone: "GMT +04:00", tzCode: "Indian/Reunion" },
    text: "(GMT+04:00) Reunion"
  },
  {
    value: { id: 165, timeZone: "GMT +04:00", tzCode: "Asia/Tbilisi" },
    text: "(GMT+04:00) Tbilisi"
  },
  {
    value: { id: 166, timeZone: "GMT +04:00", tzCode: "Asia/Yerevan" },
    text: "(GMT+04:00) Yerevan"
  },
  {
    value: { id: 167, timeZone: "GMT +04:30", tzCode: "Asia/Kabul" },
    text: "(GMT+04:30) Kabul"
  },
  {
    value: { id: 168, timeZone: "GMT +05:00", tzCode: "Asia/Aqtau" },
    text: "(GMT+05:00) Aqtau"
  },
  {
    value: { id: 169, timeZone: "GMT +05:00", tzCode: "Asia/Aqtobe" },
    text: "(GMT+05:00) Aqtobe"
  },
  {
    value: { id: 170, timeZone: "GMT +05:00", tzCode: "Asia/Ashgabat" },
    text: "(GMT+05:00) Ashgabat"
  },
  {
    value: { id: 171, timeZone: "GMT +05:00", tzCode: "Asia/Dushanbe" },
    text: "(GMT+05:00) Dushanbe"
  },
  {
    value: { id: 172, timeZone: "GMT +05:00", tzCode: "Asia/Karachi" },
    text: "(GMT+05:00) Karachi"
  },
  {
    value: { id: 173, timeZone: "GMT +05:00", tzCode: "Indian/Kerguelen" },
    text: "(GMT+05:00) Kerguelen"
  },
  {
    value: { id: 174, timeZone: "GMT +05:00", tzCode: "Indian/Maldives" },
    text: "(GMT+05:00) Maldives"
  },
  {
    value: { id: 175, timeZone: "GMT +05:00", tzCode: "Antarctica/Mawson" },
    text: "(GMT+05:00) Mawson"
  },
  {
    value: { id: 176, timeZone: "GMT +05:00", tzCode: "Asia/Yekaterinburg" },
    text: "(GMT+05:00) Moscow+02 - Yekaterinburg"
  },
  {
    value: { id: 177, timeZone: "GMT +05:00", tzCode: "Asia/Tashkent" },
    text: "(GMT+05:00) Tashkent"
  },
  {
    value: { id: 178, timeZone: "GMT +05:30", tzCode: "Asia/Colombo" },
    text: "(GMT+05:30) Colombo"
  },
  {
    value: { id: 179, timeZone: "GMT +05:30", tzCode: "Asia/Kolkata" },
    text: "(GMT+05:30) India Standard Time"
  },
  {
    value: { id: 180, timeZone: "GMT +05:45", tzCode: "Asia/Kathmandu" },
    text: "(GMT+05:45) Kathmandu"
  },
  {
    value: { id: 181, timeZone: "GMT +06:00", tzCode: "Asia/Almaty" },
    text: "(GMT+06:00) Almaty"
  },
  {
    value: { id: 182, timeZone: "GMT +06:00", tzCode: "Asia/Bishkek" },
    text: "(GMT+06:00) Bishkek"
  },
  {
    value: { id: 183, timeZone: "GMT +06:00", tzCode: "Indian/Chagos" },
    text: "(GMT+06:00) Chagos"
  },
  {
    value: { id: 184, timeZone: "GMT +06:00", tzCode: "Asia/Dhaka" },
    text: "(GMT+06:00) Dhaka"
  },
  {
    value: { id: 185, timeZone: "GMT +06:00", tzCode: "Asia/Omsk" },
    text: "(GMT+06:00) Moscow+03 - Omsk"
  },
  {
    value: { id: 186, timeZone: "GMT +06:00", tzCode: "Asia/Thimphu" },
    text: "(GMT+06:00) Thimphu"
  },
  {
    value: { id: 187, timeZone: "GMT +06:00", tzCode: "Antarctica/Vostok" },
    text: "(GMT+06:00) Vostok"
  },
  {
    value: { id: 188, timeZone: "GMT +06:30", tzCode: "Indian/Cocos" },
    text: "(GMT+06:30) Cocos"
  },
  {
    value: { id: 189, timeZone: "GMT +06:30", tzCode: "Asia/Yangon" },
    text: "(GMT+06:30) Rangoon"
  },
  {
    value: { id: 190, timeZone: "GMT +07:00", tzCode: "Asia/Bangkok" },
    text: "(GMT+07:00) Bangkok"
  },
  {
    value: { id: 191, timeZone: "GMT +07:00", tzCode: "Indian/Christmas" },
    text: "(GMT+07:00) Christmas"
  },
  {
    value: { id: 192, timeZone: "GMT +07:00", tzCode: "Antarctica/Davis" },
    text: "(GMT+07:00) Davis"
  },
  {
    value: { id: 193, timeZone: "GMT +07:00", tzCode: "Asia/Saigon" },
    text: "(GMT+07:00) Hanoi"
  },
  {
    value: { id: 194, timeZone: "GMT +07:00", tzCode: "Asia/Hovd" },
    text: "(GMT+07:00) Hovd"
  },
  {
    value: { id: 195, timeZone: "GMT +07:00", tzCode: "Asia/Jakarta" },
    text: "(GMT+07:00) Jakarta"
  },
  {
    value: { id: 196, timeZone: "GMT +07:00", tzCode: "Asia/Krasnoyarsk" },
    text: "(GMT+07:00) Moscow+04 - Krasnoyarsk"
  },
  {
    value: { id: 197, timeZone: "GMT +08:00", tzCode: "Asia/Brunei" },
    text: "(GMT+08:00) Brunei"
  },
  {
    value: { id: 198, timeZone: "GMT +08:00", tzCode: "Asia/Shanghai" },
    text: "(GMT+08:00) China Time - Beijing"
  },
  {
    value: { id: 199, timeZone: "GMT +08:00", tzCode: "Asia/Choibalsan" },
    text: "(GMT+08:00) Choibalsan"
  },
  {
    value: { id: 200, timeZone: "GMT +08:00", tzCode: "Asia/Hong_Kong" },
    text: "(GMT+08:00) Hong Kong"
  },
  {
    value: { id: 201, timeZone: "GMT +08:00", tzCode: "Asia/Kuala_Lumpur" },
    text: "(GMT+08:00) Kuala Lumpur"
  },
  {
    value: { id: 202, timeZone: "GMT +08:00", tzCode: "Asia/Macau" },
    text: "(GMT+08:00) Macau"
  },
  {
    value: { id: 203, timeZone: "GMT +08:00", tzCode: "Asia/Makassar" },
    text: "(GMT+08:00) Makassar"
  },
  {
    value: { id: 204, timeZone: "GMT +08:00", tzCode: "Asia/Manila" },
    text: "(GMT+08:00) Manila"
  },
  {
    value: { id: 205, timeZone: "GMT +08:00", tzCode: "Asia/Irkutsk" },
    text: "(GMT+08:00) Moscow+05 - Irkutsk"
  },
  {
    value: { id: 206, timeZone: "GMT +08:00", tzCode: "Asia/Singapore" },
    text: "(GMT+08:00) Singapore"
  },
  {
    value: { id: 207, timeZone: "GMT +08:00", tzCode: "Asia/Taipei" },
    text: "(GMT+08:00) Taipei"
  },
  {
    value: { id: 208, timeZone: "GMT +08:00", tzCode: "Asia/Ulaanbaatar" },
    text: "(GMT+08:00) Ulaanbaatar"
  },
  {
    value: { id: 209, timeZone: "GMT +08:00", tzCode: "Australia/Perth" },
    text: "(GMT+08:00) Western Time - Perth"
  },
  {
    value: { id: 210, timeZone: "GMT +08:30", tzCode: "Asia/Pyongyang" },
    text: "(GMT+08:30) Pyongyang"
  },
  {
    value: { id: 211, timeZone: "GMT +09:00", tzCode: "Asia/Dili" },
    text: "(GMT+09:00) Dili"
  },
  {
    value: { id: 212, timeZone: "GMT +09:00", tzCode: "Asia/Jayapura" },
    text: "(GMT+09:00) Jayapura"
  },
  {
    value: { id: 213, timeZone: "GMT +09:00", tzCode: "Asia/Yakutsk" },
    text: "(GMT+09:00) Moscow+06 - Yakutsk"
  },
  {
    value: { id: 214, timeZone: "GMT +09:00", tzCode: "Pacific/Palau" },
    text: "(GMT+09:00) Palau"
  },
  {
    value: { id: 215, timeZone: "GMT +09:00", tzCode: "Asia/Seoul" },
    text: "(GMT+09:00) Seoul"
  },
  {
    value: { id: 216, timeZone: "GMT +09:00", tzCode: "Asia/Tokyo" },
    text: "(GMT+09:00) Tokyo"
  },
  {
    value: { id: 217, timeZone: "GMT +09:30", tzCode: "Australia/Darwin" },
    text: "(GMT+09:30) Central Time - Darwin"
  },
  {
    value: {
      id: 218,
      timeZone: "GMT +10:00",
      tzCode: "Antarctica/DumontDUrville"
    },
    text: "(GMT+10:00) Dumont D'Urville"
  },
  {
    value: { id: 219, timeZone: "GMT +10:00", tzCode: "Australia/Brisbane" },
    text: "(GMT+10:00) Eastern Time - Brisbane"
  },
  {
    value: { id: 220, timeZone: "GMT +10:00", tzCode: "Pacific/Guam" },
    text: "(GMT+10:00) Guam"
  },
  {
    value: { id: 221, timeZone: "GMT +10:00", tzCode: "Asia/Vladivostok" },
    text: "(GMT+10:00) Moscow+07 - Vladivostok"
  },
  {
    value: { id: 222, timeZone: "GMT +10:00", tzCode: "Pacific/Port_Moresby" },
    text: "(GMT+10:00) Port Moresby"
  },
  {
    value: { id: 223, timeZone: "GMT +10:00", tzCode: "Pacific/Chuuk" },
    text: "(GMT+10:00) Truk"
  },
  {
    value: { id: 224, timeZone: "GMT +10:30", tzCode: "Australia/Adelaide" },
    text: "(GMT+10:30) Central Time - Adelaide"
  },
  {
    value: { id: 225, timeZone: "GMT +11:00", tzCode: "Antarctica/Casey" },
    text: "(GMT+11:00) Casey"
  },
  {
    value: { id: 226, timeZone: "GMT +11:00", tzCode: "Australia/Hobart" },
    text: "(GMT+11:00) Eastern Time - Hobart"
  },
  {
    value: { id: 227, timeZone: "GMT +11:00", tzCode: "Australia/Sydney" },
    text: "(GMT+11:00) Eastern Time - Melbourne, Sydney"
  },
  {
    value: { id: 228, timeZone: "GMT +11:00", tzCode: "Pacific/Efate" },
    text: "(GMT+11:00) Efate"
  },
  {
    value: { id: 229, timeZone: "GMT +11:00", tzCode: "Pacific/Guadalcanal" },
    text: "(GMT+11:00) Guadalcanal"
  },
  {
    value: { id: 230, timeZone: "GMT +11:00", tzCode: "Pacific/Kosrae" },
    text: "(GMT+11:00) Kosrae"
  },
  {
    value: { id: 231, timeZone: "GMT +11:00", tzCode: "Asia/Magadan" },
    text: "(GMT+11:00) Moscow+08 - Magadan"
  },
  {
    value: { id: 232, timeZone: "GMT +11:00", tzCode: "Pacific/Norfolk" },
    text: "(GMT+11:00) Norfolk"
  },
  {
    value: { id: 233, timeZone: "GMT +11:00", tzCode: "Pacific/Noumea" },
    text: "(GMT+11:00) Noumea"
  },
  {
    value: { id: 234, timeZone: "GMT +11:00", tzCode: "Pacific/Pohnpei" },
    text: "(GMT+11:00) Ponape"
  },
  {
    value: { id: 235, timeZone: "GMT +12:00", tzCode: "Pacific/Funafuti" },
    text: "(GMT+12:00) Funafuti"
  },
  {
    value: { id: 236, timeZone: "GMT +12:00", tzCode: "Pacific/Kwajalein" },
    text: "(GMT+12:00) Kwajalein"
  },
  {
    value: { id: 237, timeZone: "GMT +12:00", tzCode: "Pacific/Majuro" },
    text: "(GMT+12:00) Majuro"
  },
  {
    value: { id: 238, timeZone: "GMT +12:00", tzCode: "Asia/Kamchatka" },
    text: "(GMT+12:00) Moscow+09 - Petropavlovsk-Kamchatskiy"
  },
  {
    value: { id: 239, timeZone: "GMT +12:00", tzCode: "Pacific/Nauru" },
    text: "(GMT+12:00) Nauru"
  },
  {
    value: { id: 240, timeZone: "GMT +12:00", tzCode: "Pacific/Tarawa" },
    text: "(GMT+12:00) Tarawa"
  },
  {
    value: { id: 241, timeZone: "GMT +12:00", tzCode: "Pacific/Wake" },
    text: "(GMT+12:00) Wake"
  },
  {
    value: { id: 242, timeZone: "GMT +12:00", tzCode: "Pacific/Wallis" },
    text: "(GMT+12:00) Wallis"
  },
  {
    value: { id: 243, timeZone: "GMT +13:00", tzCode: "Pacific/Auckland" },
    text: "(GMT+13:00) Auckland"
  },
  {
    value: { id: 244, timeZone: "GMT +13:00", tzCode: "Pacific/Enderbury" },
    text: "(GMT+13:00) Enderbury"
  },
  {
    value: { id: 245, timeZone: "GMT +13:00", tzCode: "Pacific/Fakaofo" },
    text: "(GMT+13:00) Fakaofo"
  },
  {
    value: { id: 246, timeZone: "GMT +13:00", tzCode: "Pacific/Fiji" },
    text: "(GMT+13:00) Fiji"
  },
  {
    value: { id: 247, timeZone: "GMT +13:00", tzCode: "Pacific/Tongatapu" },
    text: "(GMT+13:00) Tongatapu"
  },
  {
    value: { id: 248, timeZone: "GMT +14:00", tzCode: "Pacific/Apia" },
    text: "(GMT+14:00) Apia"
  },
  {
    value: { id: 249, timeZone: "GMT +14:00", tzCode: "Pacific/Kiritimati" },
    text: "(GMT+14:00) Kiritimati"
  }
];

//Languages

export const languages = [
  { value: null, text: "Select language" },
  { value: "English", text: "English" },
  { value: "French", text: "French" },
  { value: "Dutch", text: "Dutch" },
  { value: "German", text: "German" }
];

//Infra options

export const infraOptions = [
  { value: "Asana", id: 0, text: "Asana" },
  { value: "Dropbox", id: 7, text: "Dropbox" },
  { value: "Gmail", id: 1, text: "Gmail" },
  { value: "Notion", id: 2, text: "Notion" },
  { value: "Outlook", id: 3, text: "Outlook" },
  { value: "Slack", id: 4, text: "Slack" },
  { value: "Teams", id: 5, text: "Teams" },
  { value: "Trello", id: 6, text: "Trello" }
];

//Regexes

export const linkedinRegex = /http(s)?:\/\/(?:[\w]+\.)?linkedin\.com\/in\/([a-zA-Z0-9-]{1,200})\/?/;

export const HANDOVER_REASSIGNED = "handover-reassigned";
export const HANDOVER_REQUEST_MADE = "handover-request-made";
export const HANDOVER_REQUEST_DECLINED = "handover-request-declined";
export const ASSIGN_ASSISTANT_TO_CUSTOMER = "assign-assistant-to-customer";
export const NOTIFY_TIMER_RUNNING = 'notify-timer-running';

export const BULK_ACTIONS = {
  HANDOVER: 'HANDOVER',
  ARCHIVE: 'ARCHIVE',
  STATUS_CHANGE: 'STATUS_CHANGE',
  DELETE: 'DELETE'
}
export const BOARDS = {
  MAIN: 'MAIN',
  CUSTOMER: 'CUSTOMER',
  EA: 'EA'
}
export const editorOptions = {
  placeholder: "Write here",
  modules: {
    toolbar: {
      container: [
        ["bold", "italic", "underline", "strike"], // toggled buttons
        ["blockquote", "code-block", "link"],

        [{ header: 1 }, { header: 2 }], // custom button values
        [{ list: "ordered" }, { list: "bullet" }],
        [{ indent: "-1" }, { indent: "+1" }], // outdent/indent

        [{ size: ["small", false, "large", "huge"] }], // custom dropdown

        [{ color: [] }, { background: [] }], // dropdown with defaults from theme
        [{ align: [] }]
      ],
      handlers: {}
    }
  }
};
export const statuses = ["daily", "today", "later", "in-progress", "complete"];

export const ACCEPTED_FILE_TYPES = "image/*"
  + ",.jpg,.jpeg,.png,.gif,.bmp"
  + ",.pdf,.txt"
  + ",.doc,.docx"
  + ",.xls,.xlsx"
  + ",.ppt,.pptx"

export const ACCEPTED_IMAGE_FILE_TYPES = ".jpg,.jpeg,.png,.gif,.bmp"

export const ADMIN_INVOICE_CORRECTION_REASON = "Admin: incorrect customer invoice";

export const TIMER_CORRECTION_REASONS = [
  "Forgot to start the timer",
  "Forgot to stop the timer",
  "Task added retroactively",
  "Task removed retroactively"
];

export const MIN_CORRECTION_MINUTES = 5;
export const CORRECTION_STEP_MINUTES = 5;
